import React from "react"

const Snackbar = () => {
  return <div />
}

export default Snackbar
